import { render, staticRenderFns } from "./PriceWithClub.vue?vue&type=template&id=c3dc203c&"
import script from "./PriceWithClub.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PriceWithClub.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3dc203c')) {
      api.createRecord('c3dc203c', component.options)
    } else {
      api.reload('c3dc203c', component.options)
    }
    module.hot.accept("./PriceWithClub.vue?vue&type=template&id=c3dc203c&", function () {
      api.rerender('c3dc203c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPriceBlockV2/components/PriceWithClub.vue"
export default component.exports